import React from 'react';
import styled from 'styled-components';

const AboutSection = styled.section`
  padding: 2rem;
  min-height: 60vh;
  background-color: #1a1a1a;
  color: white;
`;

function AboutPage() {
  return (
    <AboutSection>
      <h2>About simonfoy.host</h2>
      <p>
        We are dedicated to providing top-notch hosting solutions...
      </p>
    </AboutSection>
  );
}

export default AboutPage;
